import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", () => {
 document.querySelectorAll(".testimonial-swiper").forEach((element) => {
    new Swiper(element, {
        loop: true,
        slidesPerView: 1,
        speed: 1200,
        grabCursor: true,
        spaceBetween: 24,
        centeredSlides: false,
        autoplay: {
            delay: 9900,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: element.querySelector(".swiper-pagination"),
            clickable: true
        }
    });

});

  document.querySelectorAll("[data-pricing-carousel]").forEach((carousel) => {
    const swiperElement = carousel.querySelector(".pricing-swiper");
    const paginationElement = carousel.querySelector(".pricing-pagination");
    const previousButton = carousel.querySelector(".pricing-prev");
    const nextButton = carousel.querySelector(".pricing-next");

    if (!swiperElement) {
      return;
    }

    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      grabCursor: true,

      navigation: {
        prevEl: previousButton,
        nextEl: nextButton
      },

      pagination: {
        el: paginationElement,
        clickable: true,
        dynamicBullets: false
      },

      breakpoints: {
        768: {
          slidesPerView: 2
        },

        1200: {
          slidesPerView: 3
        },

        1400: {
          slidesPerView: 4
        }
      }
    });

    carousel.swiperInstance = swiper;
  });

  document
    .querySelectorAll('[data-bs-toggle="pill"]')
    .forEach((tab) => {
      tab.addEventListener("shown.bs.tab", (event) => {
        const selector = event.target.dataset.bsTarget;
        const tabPane = document.querySelector(selector);

        tabPane
          ?.querySelectorAll("[data-pricing-carousel]")
          .forEach((carousel) => {
            carousel.swiperInstance?.update();
            carousel.swiperInstance?.pagination?.render();
            carousel.swiperInstance?.pagination?.update();
          });
      });
    });

  document
    .querySelectorAll(".customer-logo-swiper")
    .forEach((element) => {
      new Swiper(element, {
        loop: true,
        speed: 5000,
        spaceBetween: 48,
        slidesPerView: 2,
        allowTouchMove: true,
        grabCursor: true,

        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },

        breakpoints: {
          576: {
            slidesPerView: 3
          },

          768: {
            slidesPerView: 4
          },

          992: {
            slidesPerView: 5
          },

          1200: {
            slidesPerView: 6
          }
        }
      });
    });

});
